module.exports = __webpack_public_path__ + "static/printer-img-10ff54be2a0f5f9abcfccce581d622bc.png";